"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRoundnessMatrix = exports.pins = void 0;
// Матрица радиусов. r - радиус стандартный, h - радиус округлый (вычисляемый из высоты)
exports.pins = {
    'square-square': 'r r r r',
    'square-clear': 'r 0 0 r',
    'clear-square': '0 r r 0',
    'clear-clear': '0 0 0 0',
    'clear-circle': '0 h h 0',
    'circle-clear': 'h 0 0 h',
    'circle-circle': 'h h h h',
};
/**
 * Преобразовывает матрицу радиусов с указанными размерами.
 * @param {string} matrixKey Ключ матрицы радиусов
 * @param {string} r r-радиус
 * @param {string} h h-радиус
 * @example
 * // Выведет значение для border-radius, равное '1em 0 0 1em'
 * convertPinsMatrix('r 0 0 r', '1em');
 * @example
 * // Выведет значение для border-radius, равное '1em 2em 2em 1em'
 * convertPinsMatrix('r h h r', '1em', '2em');
 */
exports.convertRoundnessMatrix = function (matrixKey, r, h) {
    return matrixKey &&
        exports.pins[matrixKey]
            .split(' ')
            .map(function (char) {
            switch (char) {
                case 'r':
                    return r;
                case 'h':
                    return h;
                default:
                    return char;
            }
        })
            .join(' ');
};
//# sourceMappingURL=roundness.js.map